import "./App.css";
import RouterFile from "./route/router";
import "reactjs-popup/dist/index.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {

  return (
    <Provider store={store}>
      <div className="App">
      <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          d
          draggable
          pauseOnHover
          theme="colored"
        />
        <RouterFile />
      
      </div>
    </Provider>
  );
}

export default App;
